import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Checkbox, FormControl, useToast} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useRemoveModerator, useUpdateModerator} from "../../../api/moderation";

const EditModeratorSheet = styled(({className, community, moderator, onClose}) => {

    const [info, setInfo] = useState({
        community,
        author: moderator.author,
        all_permissions: moderator.permissions.all_permissions,
        manage_rules: moderator.permissions.manage_rules,
        manage_automoderator: moderator.permissions.manage_automoderator,
        manage_settings: moderator.permissions.manage_settings,
        manage_stylesheet: moderator.permissions.manage_stylesheet,
        manage_sidebar: moderator.permissions.manage_sidebar,
    });
    const set = (name) => (value) => setInfo((info) => ({...info, [name]: value}));
    const {feedbackCh} = useFeedback();
    const toast = useToast();
    const updateModerator = useUpdateModerator(feedbackCh);
    const removeModerator = useRemoveModerator(feedbackCh);
    const [saving, setSaving] = useState(false);
    const handleSave = async () => {
        setSaving(true);
        await updateModerator(info);
        toast({
            title: `Successfully added!`,
            status: 'success',
            isClosable: true,
        });
        setSaving(false);
        onClose();
    };
    const handleRemove = async () => {
        setSaving(true);
        await removeModerator(community, info.author);
        toast({
            title: `Successfully removed.`,
            status: 'success',
            isClosable: true,
        });
        setSaving(false);
        onClose();
    };

        return (
            <div className={className}>

                <Header>
                    <Title>Edit Moderator</Title>
                </Header>

                <FormControl pb={1}>
                    <Checkbox size='md' value={info.all_permissions} isChecked={info.all_permissions}
                              onChange={(e) => set('all_permissions')(e.target.checked)}>All Permissions</Checkbox>
                </FormControl>
                <FormControl pb={1}>
                    <Checkbox size='md' value={info.manage_rules} isChecked={info.manage_rules}
                              onChange={(e) => set('manage_rules')(e.target.checked)}>Manage Rules</Checkbox>
                </FormControl>
                <FormControl pb={1}>
                    <Checkbox size='md' value={info.manage_sidebar} isChecked={info.manage_sidebar}
                              onChange={(e) => set('manage_sidebar')(e.target.checked)}>Manage Sidebar</Checkbox>
                </FormControl>
                <FormControl pb={1}>
                    <Checkbox size='md' value={info.manage_automoderator} isChecked={info.manage_automoderator}
                              onChange={(e) => set('manage_automoderator')(e.target.checked)}>Manage Filter</Checkbox>
                </FormControl>
                <FormControl pb={1}>
                    <Checkbox size='md' value={info.manage_settings} isChecked={info.manage_settings}
                              onChange={(e) => set('manage_settings')(e.target.checked)}>Manage Settings</Checkbox>
                </FormControl>
                <FormControl>
                    <Checkbox size='md' value={info.manage_stylesheet} isChecked={info.manage_stylesheet}
                              onChange={(e) => set('manage_stylesheet')(e.target.checked)}>Manage Stylesheet</Checkbox>
                </FormControl>

                <Button variant={"grey"} style={{width: '100%', marginTop: '24px'}} onClick={handleRemove}>Delete</Button>
                <Button variant={"blue"} style={{width: '100%'}} mt={2} onClick={handleSave}>Save</Button>

            </div>
        );
    }
)`
`;

export default EditModeratorSheet;
